module.exports = __webpack_public_path__ + "img/sv.93c4aaa8.svg";